import { size } from 'underscore';
import { CampaignType } from '@bingads-webui-campaign/campaign-ui-common';
import { getDropdownMenuItems, onClickSelected } from './get-dropdown-menu-items';

export const auctionInsightPlugin = definePlugin => definePlugin('auctionInsight', [
  'config',
  'gridView',
  'toolbar',
  'crossPageSelectAll',
], (config, gridView, toolbar, crossPageSelectAll) => {
  const pluginConfig = config.plugins.auctionInsight;
  const menuId = pluginConfig.isForVNext ? 'button-auction-insights' : 'dropdown-details';
  const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(menuId);
  const items = getDropdownMenuItems(pluginConfig, gridView, crossPageSelectAll);

  gridView.on('didSelect', () => {
    if (pluginConfig.isForVNext) {
      if (size(gridView.selectedItems()) === 0) return;

      const campaignType = pluginConfig.getCampaignTypeGlobalFilter();
      if (campaignType === CampaignType.Default ||
        campaignType === CampaignType.Shopping ||
        campaignType === CampaignType.All
      ) {
        toolbarEditor.update({
          id: menuId,
          type: 'button',
          iconLeftGlyphName: 'ba-Articles',
          text: pluginConfig.i18n.getString('Grid_AuctionInsightsButtonText'),
          classes: ['btn-link'],
          onClick: () => onClickSelected(pluginConfig, gridView, crossPageSelectAll),
        });
      } else {
        toolbarEditor.update({
          id: menuId,
          classes: ['hide'],
        });
      }
    } else {
      toolbarEditor.update({
        type: 'dropdown',
        id: menuId,
        button: {
          text: pluginConfig.i18n.getString('Grid_DetailsButtonText'),
          classes: ['btn', 'btn-secondary'],
        },
        menu: {
          items,
        },
      });
    }
  });
});
